import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <nav className="container-site flex items-center justify-between h-16 md:h-18">
        <Link to="/" className="flex items-center gap-2 group">
          <span className="w-8 h-8 flex items-center justify-center text-xl">
            <i className="ri-drop-fill text-primary-500"></i>
          </span>
          <span className={`font-heading text-lg font-bold tracking-wide whitespace-nowrap transition-colors ${
            isScrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
          }`}>
            黄油作坊
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled || !isHome
                  ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-3 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled || !isHome
                ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
            isScrolled || !isHome
              ? 'text-foreground-700 hover:bg-background-100'
              : 'text-background-50 hover:bg-white/10'
          }`}
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 animate-in slide-in-from-top-2 duration-200">
          <div className="container-site py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 rounded-lg transition-colors cursor-pointer"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}